module.exports = __webpack_public_path__ + "img/Newbie_Staff_01.5fc32737.png";